import { Age, Question, QuizModule, QuizModuleId } from "@common";
import { QuizSlideDataSequence, SlideData } from "@natklok/interfaces/question.interface";

const getQuizModuleSlides = ({
  quizModuleId,
  age,
  questions,
  quizModules,
}: {
  quizModuleId: QuizModuleId;
  age: Age;
  questions: Question[];
  quizModules: Record<string, QuizModule>;
}) => {
  const slides: QuizSlideDataSequence = [];

  if (quizModules[quizModuleId] === undefined) return [];

  quizModules[quizModuleId].slides.forEach((questionVariant) => {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].variant.sv === questionVariant && questions[i].fitsAges.includes(age)) {
        const question = questions[i];
        const slideData: SlideData = {
          question: question,
          state: "unanswered",
          completed: false,
          savedInStorage: false,
        };
        slides.push(slideData);
        break;
      }
    }
  });

  return slides;
};

export default getQuizModuleSlides;
